import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import BestPlacesSection from './components/BestPlacesSection';
import CabinGuidesSection from './components/CabinGuidesSection';
import FeaturedCabinSpotlight from './components/FeaturedCabinSpotlight';
import LocationIntroSection from './components/LocationIntroSection';
import FeaturedProperties from './components/FeaturedProperties';
import InsiderGuide from './components/InsiderGuide';
import GuideLinks from './components/GuideLinks';
import LocalInsights from './components/LocalInsights';
import GlenFallsFeature from './components/GlenFallsFeature';
import AboutSection from './components/AboutSection';
import HomeFAQSection from './components/HomeFAQSection';
import CTASection from './components/CTASection';
import HomeSchemaMarkup from './components/HomeSchemaMarkup';
import ReferenceBar from './components/ReferenceBar';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://glenfallscabin.com';

export default function Home() {
  return (
    <>
      <title>Best Places to Stay in Highlands, NC | Cabins &amp; Vacation Rentals Guide</title>
      <meta name="description" content="Find the best places to stay in Highlands, NC. A curated guide to luxury cabins, vacation rentals, and mountain homes in Highlands, North Carolina — including top picks near Glen Falls waterfall." />
      <meta name="keywords" content="best cabins in Highlands NC, places to stay in Highlands NC, luxury cabins Highlands North Carolina, cabins near Glen Falls, Glen Falls Luxury Cabin" />
      <meta property="og:title" content="Best Cabins in Highlands, NC | Places to Stay in Highlands, North Carolina" />
      <meta property="og:description" content="A trusted guide to the best places to stay in Highlands, NC — luxury cabins in Highlands, North Carolina, top picks near Glen Falls, and curated recommendations for every type of traveler." />
      <meta name="robots" content="index, follow" />
      <meta name="geo.region" content="US-NC" />
      <meta name="geo.placename" content="Highlands, North Carolina" />
      <meta name="geo.position" content="35.0499;-83.1985" />
      <link rel="canonical" href={`${siteUrl}/`} />
      <HomeSchemaMarkup />
      <Navbar />
      <main>
        <HeroSection />
        <BestPlacesSection />
        <CabinGuidesSection />
        <FeaturedCabinSpotlight />
        <LocationIntroSection />
        <FeaturedProperties />
        <InsiderGuide />
        <GuideLinks />
        <LocalInsights />
        <GlenFallsFeature />
        <AboutSection />
        <HomeFAQSection />
        <CTASection />
        <ReferenceBar />
      </main>
      <Footer />
    </>
  );
}
